function capitalize(string: undefined): undefined;
function capitalize(string: string): string;
function capitalize(string: string | undefined): string | undefined {
  if (!string) return undefined;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function titleCase(string: undefined): undefined;
function titleCase(string: string): string;
function titleCase(string: string | undefined): string | undefined {
  if (!string) return undefined;

  return string.toLowerCase().replace(/\S+/g, (word) => {
    return capitalize(word);
  });
}

function snakeCase(string: undefined): undefined;
function snakeCase(string: string): string;
function snakeCase(string: string | undefined): string | undefined {
  if (!string) return undefined;

  return string
    .trim()
    .toLowerCase()
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    ?.join("_");
}

function stringPresent(content: string | null | undefined): content is string {
  if (content == null || content == undefined) return false;

  return content.trim() != "";
}

export { capitalize, titleCase, snakeCase, stringPresent };
